var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBankCardCrossed = function SvgBankCardCrossed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.0001H14V16.0001H18V14.0001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41409 20.0001L2.70703 22.7072L1.29282 21.293L21.2928 1.29297L22.707 2.70718L21.3506 4.0636C21.4832 4.11325 21.6051 4.19096 21.7071 4.29302C21.8946 4.48055 22 4.73491 22 5.00012V19.0001C22 19.2653 21.8946 19.5197 21.7071 19.7072C21.5196 19.8948 21.2652 20.0001 21 20.0001H5.41409ZM7.41409 18.0001L14.4141 11.0001H20V18.0001H7.41409ZM16.4141 9.00012L19.4141 6.00012H20V9.00012H16.4141Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.00012V17.7646L4 15.7646V11.0001H8.7645L10.7645 9.00012H4V6.00012H13.7645L15.7645 4.00012H3C2.73478 4.00012 2.48043 4.10548 2.29289 4.29302C2.10536 4.48055 2 4.73491 2 5.00012Z",
    fill: "currentColor"
  })));
};
export default SvgBankCardCrossed;